var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJitsiProdLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "JitsiProdLogo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74,
    height: 75,
    viewBox: "0 0 74 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 2.548,
    y1: -1.266,
    x2: 2.742,
    y2: -0.813,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0f3060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.271,
    stopColor: "#0575ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733,
    stopColor: "#0575ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f3060"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 9.901,
    y1: -4.259,
    x2: 8.859,
    y2: -3.427,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#092d61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0575ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 3.686,
    y1: -4.244,
    x2: 3.909,
    y2: -6.456,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0f3060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457,
    stopColor: "#0575ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    stopColor: "#0575ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f3060"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 6.176,
    y1: -0.452,
    x2: 3.965,
    y2: -3.836,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    stopColor: "#fff4e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#fff4e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 14.152,
    y1: -3.019,
    x2: 11.331,
    y2: -2.862,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 5.096,
    y1: -7.208,
    x2: 3.061,
    y2: -4.091,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc768"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378,
    stopColor: "#ff8400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.774,
    stopColor: "#ff8400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 3.209,
    y1: -5.419,
    x2: 3.305,
    y2: -4.461,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 3.546,
    y1: -9.705,
    x2: 4.213,
    y2: -5.849,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.341,
    stopColor: "#ffc768"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.712,
    stopColor: "#ffc768"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 21.261,
    y1: -12.708,
    x2: 24.947,
    y2: -12.876,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff4e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#fff4e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 8.853,
    y1: -9.551,
    x2: 6.966,
    y2: -12.107,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 20.938,
    y1: -17.187,
    x2: 19.921,
    y2: -18.476,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 9.14,
    y1: -4.399,
    x2: 10.908,
    y2: -4.667,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 12.936,
    y1: -13.221,
    x2: 11.89,
    y2: -14.033,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 3.78,
    y1: -8.807,
    x2: 4.033,
    y2: -6.848,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#212a3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#404e67",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 8.147,
    y1: -8.681,
    x2: 18.891,
    y2: -14.056,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 13.788,
    y1: -18.228,
    x2: 20.349,
    y2: -17.18,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 3.855,
    y1: -8.225,
    x2: 7.321,
    y2: -9.662,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 5.622,
    y1: -6.988,
    x2: 4.019,
    y2: -5.365,
    xlinkHref: "#linear-gradient-14"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_296",
    "data-name": "Group 296",
    transform: "translate(-596.604 -552.489)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_155",
    "data-name": "Rectangle 155",
    width: 74,
    height: 75,
    rx: 6,
    transform: "translate(596.604 552.489)",
    fill: "#ffc768"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path4204",
    d: "M198.622,3181.733a6.813,6.813,0,0,1-.315-.762c0-.038-.6-3.208-.672-4.023-.3-3.557-.773-3.9-.641-7.069.08-1.921-.187-2.576.381-4.147,1.168-3.235,2.024-4.509,3.542-5.266a3.14,3.14,0,0,1,3.471.251c.286.206,1.245.855,2.131,1.442s1.939,1.3,2.339,1.582a15.435,15.435,0,0,0,1.483.907c.733.381.76.387.909.194.327-.423,1.115-1.609,1.542-2.176,2.136-2.836.124-2.521-.378-2.669a3.527,3.527,0,0,1-1.862-1.439,10.976,10.976,0,0,1-2.649-7.012c-.14-3.21.183-5.8,1.593-7.272a14.517,14.517,0,0,1,3.052-2.189c.99-.542,7.063-1.676,7.6-1.44.266.118-1.054-3.372-.294-7.909a29.946,29.946,0,0,1,1.284-3.88c.267-.469,4.675-1.977,5.928-2.714,1.4-.823,4.43-2.8,4.658-4.278.5-3.239.591-4.623.8-4.745.311-.181,2.391,4.107.983,8.151a19.9,19.9,0,0,1-2.2,3.425c-.427.558.5.819,1.034,1.625a9.3,9.3,0,0,1,.867,3.452,8.784,8.784,0,0,1-.5,3.274c-.109.155-.153.306-.1.339a2.524,2.524,0,0,0,.8-.1c.389-.085,1.232-.222,1.874-.3a3.222,3.222,0,0,1,1.958.1c1.163.358,6.82,1.724,3.21,17.531-1.2,5.237-6.776,12.147-7.478,11.612l-1.728-1.317-1.991,2.952a28.57,28.57,0,0,1-2.759,2.536,17.2,17.2,0,0,1-3.336,1.969,5.215,5.215,0,0,0-.893.367,14.256,14.256,0,0,1-4.964,1.187c-7.467.484-4.618-.418-10.8-3.411-.488-.236-1.61.955-2.963,2.186a9.923,9.923,0,0,0-2.776,3.662c-.194.456-.5,1.156-.671,1.555a12.057,12.057,0,0,0-.927,3.552,2.886,2.886,0,0,1-.14.911c-.048.03-.229-.257-.4-.638Zm8.209-13.3a4.238,4.238,0,0,0,2.091-1.066c.738-.552,1.195-1.549,1.391-1.635,1.284-.57-.959-1.083-1.8-1.648s-1.929-.983-2.672-1.551a9.1,9.1,0,0,0-1.429-.982,2.6,2.6,0,0,0-.081.845,9.574,9.574,0,0,1-.414,3.1,4.266,4.266,0,0,0-.274,1.17,1.607,1.607,0,0,0,.844,1.744C205.089,3168.807,205.337,3168.809,206.831,3168.432Zm34.682-24.217c-.312-2.093-.054-4.972-1.685-6.02-3.763-2.418-4.176-.02-4.407.51a3.378,3.378,0,0,0-.325,2.543c.886,2.944,2.018,5.551,2.556,7.643.617,2.4,1.3,3.92,1.365,5.8.048,1.337.036,1.477-.161,1.786-.28.439-4.506,1.515-6.634,2.142-.731.215-.083,1.774-.167,2.287s-1.228,3.38-.86,3.957C234.826,3170.553,242.853,3153.216,241.513,3144.215Zm-7.819,13.986a5.868,5.868,0,0,0,1.18-.37.761.761,0,0,1,.458-.1,4.107,4.107,0,0,0,1.593-.5c.026-.042,1.093-.6.879-.74s-4.384-3.207-4.982-3.519c-6.887-3.591-10.507-3.838-12.781-3.38a19.563,19.563,0,0,0-7.664,3.247c-.122.147,6.1-1.93,10.514.252a12.018,12.018,0,0,1,3.767,2.452c1.157,1.239,2.212,2.549,3.042,2.77A10.085,10.085,0,0,0,233.693,3158.2Zm-8.3-14.8c2.181-.382,5.559-4.912,5.3-5.336-.036-.057.653-1.2.542-1.223-4.081-.814-3.982-4.877-4.041-4.913s-6.016,2.813-7.389,3.407c-1.165.5.167,3.506.869,5.37.312.829,2.033,1.935,2.726,2.385A2.84,2.84,0,0,0,225.391,3143.4Zm4.7-13.825c1.177-.928,4.313-5.573,3.981-7.458-1.356-7.679-1.94-2.925-2.027-2.24-.036.284-.139.912-.228,1.4s-.2,1.184-.253,1.555a13.18,13.18,0,0,1-.307,1.451c-.119.427-.306,1.138-.417,1.579s-.482,1.528-.826,2.415-.626,1.634-.626,1.659C229.387,3130.059,229.626,3129.937,230.09,3129.571Z",
    transform: "translate(-182.307 -3112.337)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path4206",
    d: "M199.162,3770.424c1.841-7.625,3.506-8.48,7.889-11.307-.964-.548-3.337-2.364-3.331-3.331.017-2.823.483-7.742-2.63-5.7C195.184,3753.969,197.321,3766.3,199.162,3770.424Z",
    transform: "translate(-182.538 -3701.271)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path4208",
    d: "M319.454,3700.139a71.953,71.953,0,0,0,6.535,4.626c15.918.8,19.893-7.995,20.182-15.208a5.811,5.811,0,0,1-5.132-2.243c-3.249,1.066-13.086,4.057-13.257,4.729C326.893,3695.53,324.253,3698.346,319.454,3700.139Z",
    transform: "translate(-296.354 -3643.27)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-3)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path4210",
    d: "M693.7,3433.552c9.615-7.156,8.377-21.486,8.532-22.22.395-1.865-1.927-8.185-4.715-7.025-4.643,1.931,3.267,12.877,2.206,18.88-.221,1.251-4.053,2.174-6.658,2.578-.3.047-.034,4.084-1.341,5.942-.187.266,1.8,1.976,1.975,1.844Z",
    transform: "translate(-642.972 -3379.622)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-4)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path4212",
    d: "M740.038,3431.1c12.311-12.1,6.079-33.689,1.781-27.382C747.723,3402.527,748.662,3422.341,740.038,3431.1Z",
    transform: "translate(-687.974 -3378.155)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-5)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path4214",
    d: "M303.218,3763.82c.228-.307-4.022-1.762-6.59-4.075-.285-.256-.331,3.741-.6,5.408-.167,1.036,1.591,2.079,1.993,2.208C298.355,3767.469,302.283,3765.082,303.218,3763.82Z",
    transform: "translate(-274.531 -3710.703)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-6)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "path4216",
    d: "M346.6,3417.818c-1.477-7.488,1.211-11.89,11.983-13.437.052.165,11.971-3.841,16.165-3.868-1.137,1.806.013,6.265,1.393,9.931C376.14,3410.444,366.05,3413.077,346.6,3417.818Z",
    transform: "translate(-321.282 -3376.221)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-7)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "path4218",
    d: "M423.434,3591.855a13.978,13.978,0,0,1,9.287-.044c2.986,1.04,4.7,3.66,5.988,4.668,3.036,2.374,8.641-.263,9.654-.247.417.006-7.523-7.128-13.51-7.489C426.807,3588.258,421.784,3592.447,423.434,3591.855Z",
    transform: "translate(-392.882 -3551.452)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-8)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "path4220",
    d: "M666.387,3114.214c-.044,2.435-.81,8.247-3.276,12.219-1.128,1.817,4.207-2.4,4.781-6.021C668.208,3118.419,666.424,3112.273,666.387,3114.214Z",
    transform: "translate(-616.199 -3109.29)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-9)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "path4222",
    d: "M529.046,3350.632a13.512,13.512,0,0,0,6.661-6.5c.262-.565-1.275-.017-2.456-1.693-1.169-1.66-.893-3.344-1.895-3.209-3.129.421-7.3,3.372-7.3,3.372s.24,3.229,1.086,4.541A8.83,8.83,0,0,0,529.046,3350.632Z",
    transform: "translate(-486.865 -3319.148)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-10)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "path4224",
    d: "M656.688,3337.875c.79,2.865,5.178,2.346,4.261-3.231C660.553,3335.222,659.565,3338.4,656.688,3337.875Z",
    transform: "translate(-610.363 -3314.888)",
    fillRule: "evenodd",
    opacity: 0.552,
    fill: "url(#linear-gradient-11)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "path4226",
    d: "M532.964,3261.676a12.421,12.421,0,0,1-3.571-3.578c-.817-1.322-1.176-8.068.2-9.745.756-1.844,3.431-3.625,6.4-4.413-5.648,6.549-3.818,16.476,1.18,15.511A23.538,23.538,0,0,1,532.964,3261.676Z",
    transform: "translate(-491.161 -3230.431)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-12)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "path4228",
    d: "M299.4,3757.036c1.1.817,5.864,4.5,6.913,3.918C303.875,3766.911,297.46,3761.865,299.4,3757.036Z",
    transform: "translate(-277.345 -3708.191)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-13)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "path4230",
    d: "M219.926,3098.9c-1.144.667-2.519,1.412-2.792,2.086-.916,1.925-1.26,5.379-.981,5.181,2.719-1.933,5.867-2.469,7.012-3.5,3.394-3.068,4.712-9.411,4-8.471C224.856,3097.234,221.106,3098.212,219.926,3098.9Zm-17.792,42.594s-3.21-2.221-3.151-2.933c.492-5.92-.559-6.266-1.089-6.2-.64.076-3.964,2.174-4.613,8.1-.471,4.3,1.228,11.019,1.487,11.382,1.339-3.6.817-6.5,7.365-10.346Zm35.074-26.227c-.16-4.438-2.832-7.489-4.647-6.775-.77.3-1.287,2.37-1.017,3.651.24,1.137,1.873,5.534,1.991,5.906.278.879,2.153,6.267,1.82,8.855-.292,2.269-6.869,3.054-6.869,3.054s-.111,1.847-.337,3.095a12.774,12.774,0,0,1-.831,2.738s1.432,1.334,1.49,1.333S237.821,3132.281,237.208,3115.266Zm-6.866,13.748a22.431,22.431,0,0,0,3.05-.949c-1.014-.665-2.169-1.5-4.1-3.006-10.733-8.348-20.482-1.317-20.29-1.38a15.525,15.525,0,0,1,6.279-.753,12.205,12.205,0,0,1,8.317,4.666C224.675,3128.876,225.9,3129.749,230.343,3129.014Zm-4.788-18.12c.325-.281,1.453-2.408,1.25-2.458-2.848-.693-3.126-1.953-3.4-3.324-.261-1.284-.221-1.467-.76-1.289-4.36,1.44-5.565,2.231-6.233,2.785-1.045.868-.312,3.2.1,4.124.57,1.291,2.663,3.627,3.637,3.815C221.563,3114.82,224.92,3111.91,225.555,3110.894Zm3.168-7.863a4.663,4.663,0,0,0-1.2-2.211,17.076,17.076,0,0,0-2.728,2.1,2.9,2.9,0,0,0,.705,4.238c2.22,1.3,3.85-1.556,3.22-4.131Zm-1.674-3.7a8.669,8.669,0,0,0,2.606-4.983,7.036,7.036,0,0,0-.377-3.658,8.422,8.422,0,0,0-.568-1.52,25.741,25.741,0,0,1-2.879,10.7C225.165,3101.078,225.523,3100.859,227.05,3099.334ZM204.271,3118.7c-1.157,4.854,1.909,11.227,4.393,11.591,2.4.351,9.284-1.728,12.894-2.731.946-.263,1.455-.125-.638-1.878a11.718,11.718,0,0,0-8.569-2.217,44.34,44.34,0,0,0-4.892,1.021,17.028,17.028,0,0,1,8.312-4.024,15.907,15.907,0,0,1,8.8,1.026c4.617,1.8,7.022,4.478,8.974,5.384.7.323.943.173,1.218-.634.46-1.352-2.337-9.79-3.351-12.25-1.547-3.755.258-5.55-.137-5.463a11.618,11.618,0,0,0-5.014,2.917c-3.457,3.1-5.564,3.754-5.876,3.728-.987-.084-2.834-1.832-3.505-2.719-.428-.566-8.092.913-10.352,2.876A5.7,5.7,0,0,0,204.271,3118.7Zm-2.455,21.129c2.528-1.06,5-3.314,4.788-3.351-1.312-.229-6.152-3.545-6.149-3.51a24.424,24.424,0,0,1-.377,4.945A2.239,2.239,0,0,0,201.816,3139.832Zm8.156-7.418c-.484,1.078-.988,5.316-7.976,8.037a52.932,52.932,0,0,0,6.186,4.236c20.007.878,19.837-14.357,19.572-14.742a9.656,9.656,0,0,1-3.075-.625,4.891,4.891,0,0,1-1.536-1.209c-.182-.236-.21-.365-.884-.169C219.14,3128.847,209.83,3132.188,209.972,3132.414Zm-6.233-7.432c-3.573-12.483,8.965-13.062,10.953-13.543,1.537-.372,1.2-.517.878-1.97a13.071,13.071,0,0,1,.077-5.729c.369-1.8.559-2.716,1.339-3.621.628-.729,4.167-2.4,5.045-2.817,3.739-1.793,5.168-3.765,5.584-5.315a19.43,19.43,0,0,0,.53-5.713c-.048-.474.258.269,1.78,5a7.806,7.806,0,0,1-2.057,7.933c-.333.355-.171.426.276,1.166a8.562,8.562,0,0,1,1.3,4.857c-.119,1.146-.608,2.229.092,2.145.1-.012,3.2-.48,5.313.866,1.434.912,3.478,2.659,2.947,9.959-1.161,15.985-8.971,19.463-9.026,19.465-.132,0-1.593-1.513-1.68-1.334-4.478,9.251-13.719,8.919-18.872,9.016-1.03.02-5.315-3.588-5.676-3.341-4.561,3.117-5.827,3.9-7.586,11.863-.067-.126-2.439-4.333-2.341-12.794.081-6.932,3.868-10.2,5.551-10.014,2.044.229,3.07,1.3,5.948,3.187a12.175,12.175,0,0,0,2.742,1.425c1.029-.024,1.731-1.915,1.9-3.139s.333-.937-.63-1.268C206.91,3130.844,204.814,3128.569,203.74,3124.982Z",
    transform: "translate(-178.247 -3083.509)",
    fill: "#2c3b54"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "path4232",
    d: "M409.407,3694.487c1.876-1.024,12.526-4.353,12.622-4.562.07-.152-12.492,5.015-15.337,3.1a4.58,4.58,0,0,0,1.42.654,6.082,6.082,0,0,1-.667,3.12A23.033,23.033,0,0,1,409.407,3694.487Z",
    transform: "translate(-377.563 -3645.698)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-14)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "path4234",
    d: "M654.766,3296.389c-1.167.815-2.777,1.953-3.106,2.832-.194.518-.325-1.446,1-2.616C653.407,3295.945,655.005,3296.222,654.766,3296.389Z",
    transform: "translate(-605.569 -3279.079)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-15)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "path4236",
    d: "M675.126,3365c1.324.395,2.347-.414,2.907-2.156a3.715,3.715,0,0,1-.987,2.17A2.035,2.035,0,0,1,675.126,3365Z",
    transform: "translate(-627.499 -3341.131)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-16)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "path4238",
    d: "M679.935,3395.7a9.732,9.732,0,0,1,5.434-.793c1.087.049-2.047-1.218-5.608-1.02-.38.324-1.51,2.212-3.1,4.125C676.419,3398.294,679.5,3395.933,679.935,3395.7Z",
    transform: "translate(-628.946 -3370.027)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-17)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "path4240",
    d: "M368.433,3440.855c1.1-.227,2.483-.6,3.4-.693.762-.077,1.718-.507,2.452.283a11.407,11.407,0,0,1-1.434-2.433c.222.871-.769.993-1.016,1.032-5.539.875-8.871,2.367-10.552,5.141a19.577,19.577,0,0,1,7.152-3.33Z",
    transform: "translate(-335.301 -3411.138)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-18)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJitsiProdLogo);
export default __webpack_public_path__ + "static/media/JitsiProdLogo.7a8ef87f632c2c3f76704dbd67b515f4.svg";
export { ForwardRef as ReactComponent };